module.exports = __webpack_public_path__ + "images/aa-migration-wizard/illustration-main.968c85b9654c45e45c81.svg";